module.exports = __webpack_public_path__ + "static/media/welcoming.5b8afea5.svg";